import React, { useContext, useEffect, useMemo, useState } from 'react'
import { HeaderNotifSales, HeaderWeb, SidebarComponent, TableLeadDark, TableLeadLight } from '../../components'
import { Button, Col, Container, Row, Spinner, Toast } from 'react-bootstrap'
import { AuthContext, ThemeContext } from '../../auth';
import { useMediaQuery } from 'react-responsive';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../api';

function Lead() {

    const { theme } = useContext(ThemeContext);
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [loading, setLoading] = useState(true);
    const [listLead, setListLead] = useState([]);

    const retrieveLead = () => {
        setLoading(true);
        axiosAuth.get(`/api/leads?userId=${userInfo?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                // console.log(res.data.data)

                setListLead(res.data.data);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveLead();
    }, [accessToken]);


    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-1' : 'ms-3 me-1'}>
                    <Row >
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Lead
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderNotifSales userInfo={userInfo} accessToken={accessToken} />
                        </Col>
                    </Row>
                </div>
                <br />
                <br />
                {loading ? (
                    <div
                        className='d-flex justify-content-center align-items-center'
                        style={{ height: '200px' }}
                    >
                        <Spinner animation='border' style={{ color: theme === 'light' ? '#F3C623' : '#2f4b7c' }} />
                    </div>
                ) : (
                    <div className={isMobile ? 'mx-1' : 'mx-3'}>
                        <TableLeadDark
                            retrieveLead={retrieveLead}
                            listLead={listLead}
                            accessToken={accessToken}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Lead
